import { useMemo, useRef } from 'react'
import { calculateColumnWidth } from '../TwinTable/VirtualTableListing/functions'
import CRRBody from './CRRBody'
import CRRHeader from './CRRHeader'
import { ComponentRowRenderBaseProps } from './types'


type ComponentRowRenderProps = ComponentRowRenderLogicProps & {}

const ComponentRowRender: React.FC<ComponentRowRenderProps> = ({ ...rest}) => {
    const { columnWidth, ref} = useComponentRowRenderLogic({ ...rest })
    return (
        <div className='component_row_render flex-auto grid' ref={ref}>
            <CRRHeader columns={rest.columns} data={rest.data} defaultColumnWidth={columnWidth} /> 
            <CRRBody columns={rest.columns} data={rest.data} defaultColumnWidth={columnWidth} />
        </div>
    )
}

interface ComponentRowRenderLogicProps extends ComponentRowRenderBaseProps {
}

const useComponentRowRenderLogic = ({ columns }: ComponentRowRenderLogicProps) => {
    const ref = useRef<HTMLDivElement | null>(null)
    const width = ref.current?.offsetWidth
    const { columnWidth } = useMemo(() => calculateColumnWidth(width || 0, columns), [width, columns])
    return { columnWidth, ref }
}

export default ComponentRowRender